import React, { useContext } from "react";
import { Link, Navigate } from "react-router-dom";
import heroImg from "../assests/images/2204_w037_n003_308b_p1_308.jpg";
import { Contextfirst } from "..";

const First = () => {
  const { authentication } = useContext(Contextfirst);

  if (authentication) {
    return <Navigate to={"/home"} />;
  }

  return (
    <section className="relative flex min-h-[100svh] items-center overflow-hidden text-white">
      <div className="absolute inset-0 z-0" aria-hidden="true">
        <img
          src={heroImg}
          alt=""
          className="h-full w-full object-cover object-center animate-ken-burns"
        />
        <div className="absolute inset-0 bg-[linear-gradient(115deg,rgba(5,28,20,0.94)_0%,rgba(5,28,20,0.82)_48%,rgba(5,28,20,0.4)_100%),linear-gradient(180deg,rgba(5,28,20,0.15)_0%,rgba(5,28,20,0.55)_100%)]" />
        <div className="pointer-events-none absolute -left-[10%] bottom-[8%] h-[380px] w-[380px] animate-soft-pulse rounded-full bg-[radial-gradient(circle,rgba(23,191,158,0.28),transparent_68%)]" />
        <div className="pointer-events-none absolute right-[6%] top-[10%] h-[300px] w-[300px] animate-float rounded-full bg-[radial-gradient(circle,rgba(23,191,158,0.22),transparent_70%)]" />
      </div>

      <div className="relative z-[1] mx-auto flex w-full max-w-6xl items-center px-6 py-14 md:min-h-[100svh] md:px-10 lg:px-14">
        <div className="max-w-[640px]">
          <h1 className="mb-5 animate-fade-up font-display text-[clamp(3rem,8vw,5.2rem)] font-extrabold leading-none tracking-tight text-white">
            Ez<span className="text-brand-teal">Shiksha</span>
          </h1>
          <p className="mb-3.5 max-w-[30ch] animate-fade-up-1 font-display text-[clamp(1.25rem,2.5vw,1.7rem)] font-medium leading-snug text-[#f3fffb]">
            Your calm starting point for faster, clearer studying.
          </p>
          <p className="mb-9 max-w-[40ch] animate-fade-up-2 text-[1.05rem] leading-relaxed text-white/85">
            Math help, notes, grammar, and text from images — ready when you are.
          </p>

          <div className="flex flex-wrap items-center gap-3.5 animate-fade-up-3 max-md:flex-col max-md:items-stretch">
            <Link
              to="/login"
              className="inline-flex items-center justify-center rounded-full bg-brand-teal px-7 py-3.5 font-display text-[0.98rem] font-semibold text-white no-underline transition hover:-translate-y-0.5 hover:bg-brand-teal-dark hover:shadow-brand-glow"
            >
              Login
            </Link>
            <Link
              to="/signup"
              className="inline-flex items-center justify-center rounded-full border-[1.5px] border-white/45 px-7 py-3.5 font-display text-[0.98rem] font-semibold text-white no-underline transition hover:-translate-y-0.5 hover:border-white"
            >
              Signup
            </Link>
            <Link
              to="/home"
              className="inline-flex items-center justify-center px-2 py-3 font-display text-[0.95rem] font-medium text-white/80 no-underline transition hover:text-white max-md:py-1"
            >
              Continue without login
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default First;
